import {computed, inject, Injectable, Injector} from '@angular/core';
import {ILoginResponse} from '@core/api/data-access';
import {LoaderService} from '@utils';
import {DialogService} from 'primeng/dynamicdialog';
import {Observable} from 'rxjs';
import {ReAuthenticateDialogComponent} from './re-authenticate-dialog.component';
import {NgZone} from '@angular/core';
import {ActiveUserStore} from '@active-user-management';

@Injectable({
	providedIn: 'root',
})
export class ReAuthenticateService {
	constructor(private injector: Injector) {}
	readonly activeUserStore: ActiveUserStore = inject(ActiveUserStore);

	public readonly canReAuth$ = computed(() => {
		const activeUser = this.activeUserStore.user$();
		return activeUser && !activeUser.isTemporary && activeUser.username;
	});

	openReAuthenticateDialog(): Observable<ILoginResponse> {
		// force hide loader before showing dialog
		const loaderService = this.injector.get(LoaderService);
		const ngZone = this.injector.get(NgZone);

		// to make sure the loader is hidden before showing the dialog
		ngZone.runOutsideAngular(() => {
			loaderService.hideLoader();
		});

		// to force the dialog above all other elements
		const dynamicDialogEl: HTMLElement = document.querySelector('p-dynamicdialog');
		if (dynamicDialogEl) dynamicDialogEl.style.zIndex = '10000';

		// show dialog to re-authenticate user
		const dialogRef = this.injector.get(DialogService)?.open(ReAuthenticateDialogComponent, {
			header: window.translate('pages.login.re-authenticate-dialog.dialog-title'),
			showHeader: false,
			styleClass: 're-authenticate-dialog',
			closable: true,
			modal: true,
			maskStyleClass: 'z-[10000]',
			draggable: false,
			resizable: false,
			baseZIndex: 10000,
			style: {zIndex: 10000},
			autoZIndex: false,
		});

		return dialogRef?.onClose;
	}
}
